<template>
  <div>
    <LlShowClassificationList
      v-if="type==='system-class'"
      :value="value"
      :title="title"
      :classification-list="items"
      :classificationListActive="classificationListActive"
      @click="$_onClick()"
      @search="$_onSearch()"
      @input="$_onChange($event)"
    />
    <LlSearchInputButton
      v-else-if="type==='search-input-button'"
      :value="value"
      :placeholder="placeholder"
      :text-label="textLabel"
      @input="$_onChange($event)"
      @click="$_onClick()"
    />
    <DropdownMenuButton
      v-else-if="type === 'dropdown-menu-button'"
      :value="value"
      :dropdown-menu-item="items"
      :placeholder="placeholder"
      :outline="outline"
      @input="$_onChange($event)"
      @click="$_onClick()"
    />
    <DurationDatePicker
      v-else-if="type === 'duration-date-picker'"
      :value="value"
      @input="$_onChange($event)"
      @click="$_onClick()"
    />
    <StateDropdownSelectClassification
      v-else-if="type === 'dropdown-select-classification'"
      :value="value"
      :title="title"
      :placeholder="placeholder"
      :all-select-text="allSelectText"
      :menu="items"
      :outline="outline"
      @input="$_onChange($event)"
      @click="$_onClick()"
    />
  </div>
</template>
<script>
export default {
  name: "LlFilter",
  props: {
    type: {
      type: String,
      default: "",
    },
    queryField: {
      type: String,
      default: "",
    },
    hasQuery: {
      type: Boolean,
      default: false,
    },
    queryActive: {
      //觸發query時機
      type: String,
      default: "input",
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    classificationListActive: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    textLabel: {
      type: String,
      default: "",
    },
    outline: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Array, Object],
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
    submitBtn: {
      type: String,
      default() {
        return this.$t("套用");
      },
    },
    cancelBtn: {
      type: String,
      default() {
        return this.$t("取消");
      },
    },
    allSelectText: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isStart: false,
    };
  },
  computed: {
    _query() {
      return this.$route.query;
    },
  },
  mounted() {
    setTimeout(() => {
      this.$_queryInit();
      this.isStart = true;
    }, 0);
  },
  methods: {
    $_queryInit() {
      if (this.hasQuery) {
        if (this._query[this.queryField]) {
          this.$emit("input", this._query[this.queryField]);
        }
      }
    },
    $_pushQuery($event) {
      if (this.hasQuery) {
        const _query = $event;
        this.$router
          .push({
            name: this.$route.name,
            query: {
              ...this._query,
              [this.queryField]: _query,
            },
          })
          .catch(() => {});
      }
    },
    $_onChange($event) {
      this.$emit("input", $event);
      if (this.queryActive === "input" && this.isStart) {
        this.$_pushQuery($event);
      }
    },
    $_onClick($event) {
      this.$emit("click");
      if (this.queryActive === "click") {
        this.$_pushQuery($event);
      }
    },
    $_onSearch($event) {
      this.$emit("search");
      if (this.queryActive === "search") {
        this.$_pushQuery($event);
      }
    },
  },
};
</script>